module.exports = __webpack_public_path__ + "img/许昌市-c.48b97870.png";